export default "__VITE_ASSET__CAtVWCfm__"